import { TSearchTabsFilters } from 'src/components/Search/components/types';

export const SERVICE_CLIENT_ADVANCED_FILTERS_KEY =
    'service-clients-advanced-filters';

export const SERVICE_CLIENT_TABS_FILTERS: TSearchTabsFilters[] = [
    { key: 'all', label: 'Tabs.All' },
];

export const NO_DISPLAYABLE_SERVICE_CLIENT_FILTERS = [
    'page',
    'limit',
    'isSearching',
    'isQueryEnabled',
    'isTabsEnabled',
    'tabValue',
    'make',
];

export const SERVICE_CLIENT_CREATE_PATH = '/create/service-client';

/** Fields that can be toggled in the "Show rows" modal (name, email, phone are always visible). */
export const SERVICE_CLIENTS_VISIBLE_FIELDS = [
    { key: 'store', label: 'serviceClients.store' },
    { key: 'assigned', label: 'serviceClients.assigned' },
    { key: 'vehicle', label: 'serviceClients.vehicle' },
    { key: 'createdAt', label: 'serviceClients.createdAt' },
];

export const SERVICE_CLIENTS_VISIBLE_ROWS_LOCAL_STORAGE_KEY =
    'service-clients-visible-rows';
